import { render, staticRenderFns } from "./loginForm.vue?vue&type=template&id=63ed6bc2"
import script from "./loginForm.vue?vue&type=script&lang=js"
export * from "./loginForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports